module.exports = __webpack_public_path__ + "static/background-e89f1ce5835b68b1bd4eb41c652c56c4.png";